import { styled } from "../../../../lib/styled";
import { ExternalLink } from "../../../primitives/data-display/ExternalLink";

// Shrinks to the room its container gives, so the title is cut to fit wherever it is put.
const FittedLink = styled(ExternalLink)({
  minWidth: 0,
  maxWidth: "100%",
});

export interface DocumentLinkProps {
  /** The document's title, or its name when it has none. */
  title: string;
  /** Where the document is read. */
  url: string;
}

/** A document's title as a link to where it is read, opening in a new tab. A long title is cut with
 *  an ellipsis to the width its container has, and shown whole on hover. */
export function DocumentLink({ title, url }: DocumentLinkProps) {
  return (
    <FittedLink href={url} title={title} variant="body2">
      {title}
    </FittedLink>
  );
}
